(() => {
	let slideupAnimation = (section) => {
		if (
			section.querySelector(".collection-carousel__item.appear-from-bottom") !==
			null
		) {
			section
				.querySelectorAll(".collection-carousel__item.appear-from-bottom")
				.forEach((item) => {
					const btn = item?.querySelector(
						".collection-carousel__item__content__button.hover-effect"
					);

					if (btn) {
						const content = item.querySelector(
							".collection-carousel__item__content__main"
						);
						const container = content.parentNode;
						const transformValue =
							btn.clientHeight +
							parseInt(window.getComputedStyle(content).marginBottom);

						container.style = `--translate: ${transformValue}px`;
					}
				});
		}
	};

	let placeNextPrevButtons = (section_id, img_selector) => {
		let nextBtn = document.querySelector(`#${section_id} .swiper-button-next`);
		let prevBtn = document.querySelector(`#${section_id} .swiper-button-prev`);
		let imageHeight = document.querySelector(
			`#${section_id} ${img_selector}`
		)?.clientHeight;

		if (nextBtn && prevBtn && imageHeight) {
			let topValue = (btn) => `${(imageHeight - btn.clientHeight) / 2}px`;
			nextBtn.style.top = topValue(nextBtn);
			prevBtn.style.top = topValue(prevBtn);
		}
	};

	let calculateSlidesPerView = (
		productCount,
		productCountMobile,
		windowWidth
	) => {
		if (windowWidth < 576) return productCountMobile;

		switch (productCount) {
			case 8:
				if (windowWidth < 750) return 2;
				if (windowWidth < 1100) return 3;
				if (windowWidth < 1360) return 4;
				if (windowWidth < 1600) return 6;
				return 8;
			case 7:
				if (windowWidth < 750) return 2;
				if (windowWidth < 1100) return 3;
				if (windowWidth < 1360) return 4;
				if (windowWidth < 1600) return 5;
				return 7;
			case 6:
				if (windowWidth < 750) return 2;
				if (windowWidth < 1100) return 3;
				if (windowWidth < 1360) return 4;
				if (windowWidth < 1600) return 5;
				return 6;
			case 5:
				if (windowWidth < 750) return 2;
				if (windowWidth < 1100) return 3;
				if (windowWidth < 1360) return 4;
				return 5;
			case 4:
				if (windowWidth < 750) return 2;
				if (windowWidth < 1100) return 3;
				return 4;
			case 3:
				if (windowWidth < 750) return 2;
				return 3;
			case 2:
				return 2;
			default:
				return productCountMobile;
		}
	};

	// NegoStore (perf 20.10.2026): pozele caruselului vin din collection-carousel.liquid cu data-srcset /
	// data-src (defer_cc_images), ca pe telefon sa nu concureze imaginea LCP din hero. Le punem inapoi o
	// singura data, pentru toata sectiunea (deci si slide-urile din dreapta, ca o glisare rapida sa nu dea
	// de carduri goale), la primul dintre:
	// - load + idle (setTimeout 1 s unde nu exista requestIdleCallback);
	// - cardurile ajung la 400 px de ecran (IntersectionObserver pe .collection-carousel__main, nu pe
	//   sectiune, al carei titlu e cu ~110 px mai sus); pe un telefon 390x844 cardurile incep la ~1490 px,
	//   adica ~640 px sub primul ecran, deci nu porneste la incarcare, ci cand clientul deruleaza spre ele;
	// - atingere, click sau focus in sectiune.
	// Se leaga inaintea Swiper-ului, in bucla proprie, ca pozele sa revina chiar daca Swiper ar arunca.
	let armDeferredImages = (section) => {
		if (section.dataset.negoDeferArmed) return;
		if (!section.querySelector("img[data-srcset], img[data-src]")) return;
		section.dataset.negoDeferArmed = "true";

		let restored = false;
		let observer = null;
		let restore = () => {
			if (restored) return;
			restored = true;
			if (observer) observer.disconnect();
			section
				.querySelectorAll("img[data-srcset], img[data-src]")
				.forEach((img) => {
					if (img.dataset.srcset) img.srcset = img.dataset.srcset;
					if (img.dataset.src) img.src = img.dataset.src;
					img.removeAttribute("data-srcset");
					img.removeAttribute("data-src");
				});
		};

		if (
			typeof window.IntersectionObserver !== "function" ||
			(window.Shopify && window.Shopify.designMode)
		) {
			restore();
			return;
		}

		observer = new window.IntersectionObserver(
			(entries) => {
				if (entries.some((entry) => entry.isIntersecting)) restore();
			},
			{ rootMargin: "400px 0px" }
		);
		observer.observe(
			section.querySelector(".collection-carousel__main") || section
		);

		let restoreWhenIdle = () => {
			if (typeof window.requestIdleCallback === "function") {
				window.requestIdleCallback(restore, { timeout: 2000 });
			} else {
				setTimeout(restore, 1000);
			}
		};
		if (document.readyState === "complete") {
			restoreWhenIdle();
		} else {
			window.addEventListener("load", restoreWhenIdle, { once: true });
		}

		["pointerdown", "touchstart", "focusin"].forEach((type) => {
			section.addEventListener(type, restore, { once: true, passive: true });
		});
	};

	let initProductCarouselSliders = () => {
		document
			.querySelectorAll(".collection-carousel-section")
			.forEach(armDeferredImages);

		document
			.querySelectorAll(".collection-carousel-section")
			.forEach((section) => {
				if (section.classList.contains("slider_started")) return;

				let slideEl = section.querySelector(".swiper-wrapper");
				let productCount = parseInt(slideEl.dataset.count);
				let productCountMobile = parseInt(slideEl.dataset.countMobile);
				let id = section.id;

				let createSwiper = () => {
					let windowWidth = window.innerWidth;
					let slidesPerView = calculateSlidesPerView(
						productCount,
						productCountMobile,
						windowWidth
					);

					return new Swiper(`#${id} .swiper--collections`, {
						loop: false,
						allowTouchMove: true,
						slidesPerView,
						lazy: true,
						preloadImages: false,
						spaceBetween: 24,
						navigation: {
							nextEl: `#${id} .swiper-button-next`,
							prevEl: `#${id} .swiper-button-prev`,
						},
						pagination: {
							el: `#${id} .swiper-pagination`,
							clickable: true,
						},
					});
				};

				section.classList.add("slider_started");
				let productSwiper = createSwiper();
				placeNextPrevButtons(id, `.collection-carousel__item-inner`);

				slideupAnimation(section);

				window.addEventListener("resize", () => {
					let windowWidth = window.innerWidth;
					let slidesPerView = calculateSlidesPerView(
						productCount,
						productCountMobile,
						windowWidth
					);
					productSwiper.params.slidesPerView = slidesPerView;
					productSwiper.update();
					placeNextPrevButtons(id, `.collection-carousel__item-inner`);
					slideupAnimation(section);
				});
			});
	};

	document.addEventListener("shopify:section:load", initProductCarouselSliders);
	document.addEventListener(
		"shopify:section:select",
		initProductCarouselSliders
	);

	initProductCarouselSliders();
})();
